import React from 'react'

import classNames from 'classnames'

export interface GridProps {
    children: React.ReactNode
    reverse?: string[]
    justify?: string[]
    align?: string[]
    equalHeight?: boolean
    gutter?: 'none' | 'wide'
    className?: string
    element?: React.ElementType
}

const Grid = (props: GridProps): JSX.Element => {
    const className: string = classNames(
        'grid',
        {
            'grid--equalheight': !!props.equalHeight,
            [`grid--gutter-${props.gutter}`]: !!props.gutter,
        },
        props.reverse?.map((reverse: string) => 'grid--reverse-' + reverse),
        props.justify?.map((justify: string) => 'grid--' + justify),
        props.align?.map((align: string) => 'grid--' + align),
        props.className
    )

    const Element = props.element || 'div'

    return <Element className={className}>{props.children}</Element>
}

export default Grid
